const ar = {
  brand: "جرافيتي",
  home: "الرئيسية",
  link: "رابط",
  dropdown: "القائمة",
  action: "إجراء",
  anotherAction: "إجراء آخر",
  somethingElse: "شيء آخر",
  disabled: "معطل",

  // topNav النصوص الخاصة بالـ 
  callback: "تواصل معنا",
  hideOverlay: "إخفاء الطبقات",
  showOverlay: "اظهار الطبقات",
  showRadius: "إظهار نصف القطر",
  hideRadius: "اخفاء نصف القطر",
  lang: "EN",
  changeLang: "تغيير اللغة",
  filter: "تصفية حسب",

  // النصوص الخاصة بالـ sideNav
  mapFilter: "فلتر الخريطة",
  showAll: "إظهار الكل",
  landmarks: "المعالم",
  roads: "الطرق",
  developers: "المطورون",

  // dropdown ف ال topNav
  jeddahPage: "جدة",
  gravityPage: "جرافيتي",
  ExploreTour: "استكشاف الجولة",

  // form
title_form: "تواصل معنا",
  firstName: "الاسم الأول",
  lastName: "اسم العائلة",
  email: "البريد الإلكتروني",
  phone: "رقم الهاتف",
  residence: "محل الإقامة",
  nationality: "الجنسية",
  message: "الرسالة",
  send: "إرسال",
  loading: "جاري الإرسال...",


   // statistics
  totalLandArea: "إجمالي مساحة الأرض : ",
  totalResidence: "إجمالي الوحدات السكنية : ",
  landscape: "المساحات الخضراء : ",
  totalResiUnits: "إجمالي عدد الوحدات السكنية : ",
  projectBUA: "المساحة البنائية للمشروع : ",

  // notes
  captionNotes: "إذا واصلت استخدام هذا الموقع، فإنك توافق على الشروط والأحكام.",
  ViewFull: "عرض الشروط والأحكام الكاملة ",
  DescriptionNotes1: `تعلن شركة ثابت المساكن العقارية بموجب هذا أن الجولة الافتراضية، بما في ذلك وسائل الراحة المعروضة في العقارات، لا تشكل جزءًا من أي عرض أو عقد للبيع أو الشراء.`,
  DescriptionNotes2: `تخضع جميع الرسومات والصور والرسوم التوضيحية والمخططات والمواصفات والشروط والأحكام والتفاصيل الأخرى الواردة في هذه الجولة الافتراضية للتغيير دون إشعار مسبق. قد تختلف الصور المعروضة في هذه الجولة الافتراضية عن المنتج النهائي.`,
  DescriptionNotes3: `جميع الأثاث والأجهزة الإلكترونية والبضائع ووسائل الراحة والمناظر الطبيعية والإكسسوارات، مثل مخططات الألوان، تهدف فقط إلى تقديم فكرة عامة عن الطابع السكني للوحدات.`,
  DescriptionNotes4: ` لا تضمن شركة ثابت المساكن العقارية دقة أو استقرار التطوير المستقبلي المعروض، أو توفر وسائل الراحة والخدمات الحالية أو المستقبلية، أو موقعها. جميع التفاصيل المقدمة عرضة للتغيير بناءً على الظروف المستقبلية.`,
  DescriptionNotes5: ` جميع المسافات والأحجام تقريبية ولأغر اض التوجيه فقط، وليست على مقياس. أي تقديرات للمسافات أو أوقات السفر هي مؤشرات وليست نهائية.`,
  btnNotes: "موافق",  











  //  masterplan
  // masterplan => filter 
  search: "بحث",
reset: "اعادة تعيين",
min: "أدنى",
max: " أكبر",
to: "إلى",
bedrooms: "غرف النوم",
bathrooms: "الحمامات",
area: "المساحة (متر مربع)",
showResult: "عرض النتائج",
// showSideMenu 
showed: "تم عرض",
of: "من",
showMore: "عرض المزيد",


};

export default ar;
